import { Injectable } from '@angular/core';
import { MixtureCategoryDTO } from '@scip/api';
import { MixtureCategoryControllerService } from '@scip/api';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MixtureCategoryService {
  // Lets load the mixture categories from the backend, but only once per ui-session
  private readonly allMixtureCategories: Observable<MixtureCategoryDTO[]> = this.mixCatService.getAllMaterialCategories().pipe(shareReplay(1));

  constructor(private mixCatService: MixtureCategoryControllerService) {}

  getAllMixtureCategories(): Observable<MixtureCategoryDTO[]> {
    return this.allMixtureCategories;
  }
}
